import { render } from "./CreatePRAttachment.vue?vue&type=template&id=3d66570e"
import script from "./CreatePRAttachment.vue?vue&type=script&lang=js"
export * from "./CreatePRAttachment.vue?vue&type=script&lang=js"

import "./CreatePRAttachment.vue?vue&type=style&index=0&id=3d66570e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__